<template>
  <v-container class="pa-0" fluid>
    <v-row no-gutters>
      <v-col cols="2">
        <v-navigation-drawer :height="$store.state.windowSize.y - 50" class="grey lighten-3" width="100%" permanent>
          <v-list>
            <v-list-item @click="swapComponent('Visits')" v-bind:class="{ 'brown lighten-4': currentComponent == 'Visits' }">
              <v-list-item-icon>
                <v-icon>{{ mdiAccountGroup }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('label.visitPlanning') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.employeeSettings.approval"
              @click="swapComponent('Approval')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'Approval' }"
            >
              <v-list-item-icon>
                <v-icon>{{ mdiAccountMultipleCheck }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $tc('label.approval', 1) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              @click="swapComponent('ArchiveByEmployee')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'ArchiveByEmployee' }"
            >
              <v-list-item-icon>
                <v-icon>{{ mdiArchive }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $tc('label.archive', 1) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </v-col>

      <v-col cols="10">
        <div :is="currentComponent" :swap-component="swapComponent" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import ArchiveByEmployee from '@/components/employeeview/ArchiveByEmployee.vue';
import Visits from '@/components/employeeview/Visits.vue';
import Approval from '@/components/employeeview/Approval.vue';

import { mdiAccountGroup, mdiAccountMultipleCheck, mdiArchive } from '@mdi/js';

export default Vue.extend({
  name: 'EmployeeView',
  components: {
    ArchiveByEmployee,
    Visits,
    Approval,
  },
  data: () => ({
    currentComponent: 'Visits',
    mdiAccountGroup: mdiAccountGroup,
    mdiAccountMultipleCheck: mdiAccountMultipleCheck,
    mdiArchive: mdiArchive,
  }),
  mounted() {
    // this.$store.dispatch('checkLogin').catch(() => this.$router.push('/'));
  },
  methods: {
    swapComponent(component: string) {
      this.currentComponent = component;
    },
  },
});
</script>
